import React, { useContext } from 'react';
var MessageBarContext = React.createContext(undefined);
export var MessageBarContextProvider = MessageBarContext.Provider;
export var useMessageBar = function () {
    var messageBarContext = useContext(MessageBarContext);
    if (!messageBarContext) {
        throw new Error('No Context value found for `MessageBarContext`. Did you forget to wrap your application in the `MessageBarContextProvider`?');
    }
    return messageBarContext;
};
//# sourceMappingURL=MessageBarContext.js.map